import React, { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose, duration = 3000, onConfirm, onCancel }) {
  useEffect(() => {
    if (type !== 'confirm') {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
    // No auto-close for confirm toasts
  }, [duration, onClose, type]);

  const icons = {
    success: '✓',
    error: '✕',
    info: 'ℹ',
    warning: '⚠',
    confirm: '?' // Icon for confirmation toasts
  };

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-icon">{icons[type]}</div>
      <div className="toast-message">{message}</div>
      {type === 'confirm' ? (
        <div className="toast-actions">
          <button className="toast-confirm-btn" onClick={onConfirm}>Confirm</button>
          <button className="toast-cancel-btn" onClick={onCancel}>Cancel</button>
        </div>
      ) : (
        <button className="toast-close" onClick={onClose}>×</button>
      )}
    </div>
  );
}

export function ToastContainer({ toasts, removeToast }) {
  console.log('🔔 ToastContainer rendering with toasts:', toasts.length);
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
          onConfirm={toast.onConfirm} // Pass onConfirm for confirm type
          onCancel={toast.onCancel}   // Pass onCancel for confirm type
        />
      ))}
    </div>
  );
}